/**
 * Rating — komponent gwiazdkowej oceny (F12.B T12.B.2).
 * Adaptacja z SellCall.
 */

import { Heart, Star, ThumbsUp } from 'lucide-react';

interface RatingProps {
  value: number;
  onChange: (rating: number) => void;
  max?: number;
  icon?: 'star' | 'heart' | 'thumbsup';
  readonly?: boolean;
  size?: 'sm' | 'md' | 'lg';
}

export function Rating({
  value,
  onChange,
  max = 5,
  icon = 'star',
  readonly = false,
  size = 'md',
}: RatingProps) {
  const IconComponent = icon === 'heart' ? Heart : icon === 'thumbsup' ? ThumbsUp : Star;

  const sizeClass = size === 'sm' ? 'h-4 w-4' : size === 'lg' ? 'h-7 w-7' : 'h-5 w-5';

  const filledClass =
    icon === 'heart'
      ? 'fill-red-500 text-red-500'
      : icon === 'thumbsup'
        ? 'fill-accent-500 text-accent-500'
        : 'fill-yellow-400 text-yellow-400';

  return (
    <div className="flex items-center gap-1">
      {Array.from({ length: max }).map((_, i) => (
        <button
          key={i}
          type="button"
          onClick={() => !readonly && onChange(i + 1)}
          disabled={readonly}
          className={`focus:outline-none transition-transform hover:scale-110 ${readonly ? 'cursor-default' : 'cursor-pointer'}`}
          aria-label={`Oceń ${i + 1} z ${max}`}
        >
          <IconComponent
            className={`${sizeClass} ${i < value ? filledClass : 'text-border-primary'}`}
          />
        </button>
      ))}
      <span className="ml-1 text-xs text-text-tertiary">
        {value}/{max}
      </span>
    </div>
  );
}
